export default {
  blogHelpers: {},
  blog: {}
}



// WEBPACK FOOTER //
// ./src/components/blog/store/state.js